import script from "./DashboardContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardContainer.vue?vue&type=script&setup=true&lang=js"

import "./DashboardContainer.vue?vue&type=style&index=0&id=2b3ea9d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b3ea9d6"]])

export default __exports__